import React from 'react';
import { IonItem, IonReorder, IonRow, IonCol, IonText, } from '@ionic/react';
import styled from 'styled-components';
import { get } from 'lodash';
import '@ionic/react/css/core.css';
import Dinero from 'dinero.js';
import { formatDescription } from '../../text';
const Price = styled.div `
  font-weight: 500 !important;
  border-radius: 20px;
  border: 1px solid;
  padding: 0 6px;
  font-size: 14px;
`;
const Text = styled(IonText) `
  margin: 0;
  padding: 0;
  line-height: 1em;
`;
const IonItemWrapper = styled(IonItem) `
  margin-top: .6em;
`;
const Col = styled(IonCol) `
  display: flex;
  flex: ${(props) => props.flex};
  justify-content: center;
  flex-direction: column;
  padding: 5px 0;
  align-items: ${(props) => props.alignItems};
`;
export const Vertical = ({ product, read = false, theme = null, children, }) => {
    const { reference, price, description, id, stock, tva, settingFields, disponibility, } = product;
    return (React.createElement(IonItemWrapper, { color: get(theme, 'color.background'), lines: "none" },
        React.createElement(IonReorder, { slot: "end" }),
        React.createElement(Col, { alignItems: "flex-start", flex: "0.75" },
            React.createElement(IonRow, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        paddingBottom: '3px',
                    } },
                    React.createElement(Text, { style: { marginRight: '10px', fontWeight: '500' }, color: get(theme, 'color.productTitle') }, reference),
                    React.createElement(Text, { style: { fontWeight: '500', whiteSpace: 'nowrap' }, color: get(theme, 'color.productTitle') },
                        React.createElement(Price, null, `${Dinero({ amount: parseInt(price, 10) }).toFormat('0.0')} €`)))),
            React.createElement(IonRow, null,
                React.createElement(Text, { color: get(theme, 'color.productDescription') }, formatDescription(description)))),
        React.createElement(Col, { alignItems: "flex-end", flex: "0.25" }, read && React.cloneElement(children, {
            id, reference, price, stock, tva, settingFields, disponibility, description,
        }))));
};
